import Candidates from "./Candidates.jsx";
import ClientBoard from "./ClientBoard.jsx";
import Dashboard from "./Dashboard.jsx";
import DataManagment from "./DataManagment.jsx";
import EvaluationForms from "./EvaluationForms.jsx";
import JobRequets from "./JobRequets.jsx";
import Positions from "./Positions.jsx";
import Reports from "./Reports.jsx";
import Requisition from "./Requisition.jsx";
import Settings from "./Settings.jsx";
import MiniLogo from "./MiniLogo.jsx";
import Search from "../../comman/Search.jsx";
import Message from "./Message.jsx";
import Notification from "./Notification.jsx";
import Arrow from "../../comman/Arrow.jsx";
import ClientReports from "./ClientReports.jsx";

import fullLogoPath from "../../logos/full-logo.webp";
import logoPath from "../../logos/logo_no_bg.webp";
import Switch from './switch.png'
import Switch2 from './switch2.png'

export const FullLogo = fullLogoPath;
export const Logo = logoPath;

export {
  Candidates,
  ClientBoard,
  Dashboard,
  DataManagment,
  EvaluationForms,
  JobRequets,
  Positions,
  Reports,
  Requisition,
  Settings,
  MiniLogo,
  Search,
  Message,
  Notification,
  Arrow,
  ClientReports,
  Switch,
  Switch2
};
